module.exports = __webpack_public_path__ + "assets/img/index-partner24.4b4b9581.jpg";